<template>
  <button
    class="sc-user-input--button-icon-wrapper microphonebtn"
    :style="{ color: activeColor }"
  >
    <i
      class="fa fa-microphone d-inline-block"
      style="{font-weight: 100}"
      aria-hidden="true"
    />
  </button>
</template>

<script>
export default {
  components: {},
  props: {
    activeColor: { type: String, default: '#01509F' }
  }
}
</script>

<style scoped>
.microphonebtn {
  background: #73d7f1;
  border: 0px;
  color: #01509f;
  margin-top: 0;
  height: 30px;
  width: 30px;
  border-radius: 100%;
  line-height: 30px;
  text-align: center;
  padding-top: 3px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 7px;
}
</style>
